import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Map } from 'immutable';

import { history } from 'flow/configure-store';
import { generatePath } from 'flow/utils/router-utils';
import { routes } from 'flow/types/routes';
import { createSession } from 'flow/actions/chat-actions';
import Loading from 'flow/components/ui-components/Loading';

/**
 * This component acts as a loading layer for opening
 * conference lobbys with only the chatUserKey available.
 * This will mount a loading spinner while fetching relevant
 * data to be able to open the one-on-one conference lobby.
 *
 * Since the userToSession map only gets populated as sessions
 * are created, it is very likely that the desired one-on-one
 * chat session exists in the list, thus needing to use
 * createSession(...).
 */

const RedirectConferenceLobby = (props) => {
    const { chatUserKey, userToSession, createChatSession, redirectToLobby } =
        props;

    useEffect(() => {
        const chatSessionKey = userToSession.get(chatUserKey);
        if (chatSessionKey) {
            redirectToLobby(chatSessionKey);
        } else {
            createChatSession(chatUserKey);
        }
    }, [chatUserKey, userToSession, redirectToLobby, createChatSession]);

    return <Loading />;
};

RedirectConferenceLobby.propTypes = {
    chatUserKey: PropTypes.string.isRequired,
    userToSession: PropTypes.instanceOf(Map).isRequired,
    createChatSession: PropTypes.func.isRequired,
    redirectToLobby: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
    const { chats } = state;
    const {
        match: {
            params: { chatUserKey },
        },
    } = ownProps;

    const userToSession = chats.get('userToSession');

    return { userToSession, chatUserKey };
};

const mapDispatchToProps = (dispatch) => ({
    createChatSession: (chatUserKey) => dispatch(createSession(chatUserKey)),
    redirectToLobby: (chatSessionKey) =>
        history.push(
            generatePath(routes['messages.id.lobby'], { id: chatSessionKey }),
        ),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(RedirectConferenceLobby);
